import { ReactNode } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { getCgoColor } from "src/components/playerColors";
import { AllStats, OverviewStat, PlayerColorInfo, StatValue } from "src/components/types";
import { stripWidthFromStyle } from "src/components/gametable/redesign/utility";

export default function OverviewResultsTable(props: {
  allStats: AllStats;
  playerColors: PlayerColorInfo[];
  overviewStats?: OverviewStat[];
}) {
  let header = [
    <TableCell key="overviewcatheader" className="result-table-header" component="th">
      Category
    </TableCell>,
  ];

  for (let pci of props.playerColors) {
    header.push(
      <TableCell
        style={{ color: getCgoColor(pci.color) }}
        key={"overviewcolorheader_" + pci.color}
        className="result-table-header playername-header"
        component="th"
      >
        {pci.userInfo?.username ?? "dummy-" + pci.color}
      </TableCell>,
    );
  }

  function generateStatRow(statName: string, rows: ReactNode[]) {
    let matchingOverviewStat = props.overviewStats?.find((stat) => stat.name == statName);
    let cells = [
      <TableCell key={"overview-stat-header-" + statName} component="th">
        {matchingOverviewStat?.displayName || statName}
      </TableCell>,
    ];
    for (let pci of props.playerColors) {
      let cellValue: StatValue = "";
      let cellStyle = stripWidthFromStyle(matchingOverviewStat?.customStyle || {});
      if (props.allStats.playerStats[statName]) {
        cellValue = props.allStats.playerStats[statName][pci.color] ?? "";
      }
      if (Array.isArray(cellValue)) {
        cellValue = cellValue.join(", ");
      }
      cells.push(
        <TableCell key={"overview-stat-" + pci.color + "-" + statName} style={cellStyle}>
          {cellValue}
        </TableCell>,
      );
    }
    rows.push(<tr key={"overview-stat-row-" + statName}>{cells}</tr>);
  }

  let overviewRows = [] as ReactNode[];
  let overviewStatNames =
    props.overviewStats
      ?.filter((stat) => props.playerColors.find((c) => props.allStats.playerStats?.[stat.name]?.[c.color]))
      .map((ostat) => ostat.name) ?? [];
  for (let statName of overviewStatNames) {
    generateStatRow(statName, overviewRows);
  }

  return (
    <div className="result-table-wrap">
      <TableContainer sx={{ width: "70%", flex: "1" }}>
        <Table className="result-table" stickyHeader>
          <TableHead>
            <TableRow key="headerrow">{header}</TableRow>
          </TableHead>
          <TableBody>{overviewRows}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
